import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"float":"left"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","background-color":"#409eff"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " L/Φ(长度/直径)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " W/Φ(宽度/直径)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " H(高度)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 体积(CBM) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 净重(KGS) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"15% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 毛重(KGS) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"10% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 数量 ")
  ])
], -1)
const _hoisted_4 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_5 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_6 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_7 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_8 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_9 = { style: {"float":"left","width":"15% !important","text-align":"center"} }
const _hoisted_10 = { style: {"float":"left","width":"10% !important","text-align":"left"} }
const _hoisted_11 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " L/Φ(长度/直径)(cm) ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " W/Φ(宽度/直径)(cm) ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " H(高度)(cm) ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 体积(CBM) ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 净重(KGS) ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 毛重(KGS) ")
], -1)
const _hoisted_18 = {
  key: 0,
  style: {"float":"left","width":"11% !important","color":"#fff","text-align":"center"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 数量 ", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  style: {"float":"left","width":"5% !important","color":"#fff","text-align":"center"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 操作 ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  style: {"float":"left","width":"16% !important","color":"#fff","text-align":"center"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 操作 ", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_28 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_29 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_30 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_31 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_32 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_33 = {
  key: 0,
  style: {"float":"left","width":"11% !important","text-align":"left"}
}
const _hoisted_34 = {
  key: 1,
  style: {"float":"left","width":"5% !important","text-align":"center","padding-top":"3px"}
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  style: {"float":"left","width":"16% !important","text-align":"center","padding-top":"3px"}
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { style: {"margin-top":"5px"} }
const _hoisted_39 = {
  key: 0,
  style: {"color":"red","font-size":"14px"}
}
const _hoisted_40 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_41 = { style: {"float":"left","width":"4% !important","color":"#fff","text-align":"center"} }
const _hoisted_42 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"48% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 规格型号名称 ")
], -1)
const _hoisted_45 = { style: {"float":"left","width":"48% !important","color":"#fff","text-align":"center"} }
const _hoisted_46 = { style: {"width":"100%"} }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { style: {"float":"left","width":"4% !important","text-align":"center"} }
const _hoisted_50 = { style: {"float":"left","width":"48% !important","text-align":"center"} }
const _hoisted_51 = { style: {"float":"left","width":"48% !important","text-align":"left"} }
const _hoisted_52 = {
  key: 1,
  style: {"width":"100% !important","text-align":"center","height":"60px","line-height":"60px","border-bottom":"1px solid #efefef"}
}
const _hoisted_53 = {
  key: 2,
  style: {"width":"100% !important","text-align":"center","height":"60px","line-height":"60px","border-bottom":"1px solid #efefef"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "包装内的产品与数量", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","background-color":"#409eff"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"24% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 产品名称 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"24% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 规格型号名称 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"24% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 包装内的数量 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"24% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 单位 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"4% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 操作 ")
  ])
], -1)
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { style: {"float":"left","width":"24% !important","text-align":"center"} }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { style: {"float":"left","width":"24% !important","text-align":"center"} }
const _hoisted_61 = { style: {"float":"left","width":"24% !important","text-align":"left"} }
const _hoisted_62 = { style: {"float":"left","width":"24% !important","text-align":"center"} }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { style: {"float":"left","width":"4% !important","text-align":"center"} }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = {
  key: 1,
  style: {"width":"100% !important","text-align":"center","height":"60px","line-height":"60px","border-bottom":"1px solid #efefef"}
}
const _hoisted_68 = { style: {"margin-top":"5px"} }
const _hoisted_69 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_70 = { style: {"float":"left","width":"4% !important","color":"#fff","text-align":"center"} }
const _hoisted_71 = { style: {"border-right":"1px solid #efefef","width":"100%"} }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"48% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 规格型号名称 ")
], -1)
const _hoisted_73 = { style: {"float":"left","width":"48% !important","color":"#fff","text-align":"center"} }
const _hoisted_74 = { style: {"width":"100%"} }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { style: {"float":"left","width":"4% !important","text-align":"center"} }
const _hoisted_78 = { style: {"float":"left","width":"48% !important","text-align":"center"} }
const _hoisted_79 = { style: {"float":"left","width":"48% !important","text-align":"left"} }
const _hoisted_80 = {
  key: 1,
  style: {"width":"100% !important","text-align":"center","height":"60px","line-height":"60px","border-bottom":"1px solid #efefef"}
}
const _hoisted_81 = {
  key: 2,
  style: {"width":"100% !important","text-align":"center","height":"60px","line-height":"60px","border-bottom":"1px solid #efefef"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_miezz_form, {
      ref: "ruleForm",
      modelValue: _ctx.form,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form) = $event)),
      fix: true,
      key: _ctx.random
    }, {
      "form-item": _withCtx(({ item }) => [
        (item.Prop == 'ProductId' && _ctx.type != '20' && (_ctx.productId==null || _ctx.productId==undefined || _ctx.productId==''))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.ProductId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.ProductId) = $event)),
                  disabled: _ctx.id != undefined ? true : false,
                  options: _ctx.products,
                  valueKey: "Id",
                  onHandleChange: _ctx.onChangeProductId,
                  labelKey: "Name",
                  style: {"width":"100% !important"}
                }, null, 8, ["modelValue", "disabled", "options", "onHandleChange"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : (item.Prop == 'ProductId' && (_ctx.product != null && _ctx.product != undefined))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.product.Name), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            : _createCommentVNode("", true),
        (item.Prop == 'Code')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.form.Data.Code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.Code) = $event)),
                  placeholder: '请填写'
                }, null, 8, ["modelValue"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageZhId')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.Data.PackageZhId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.PackageZhId) = $event)),
                  clearable: "",
                  placeholder: "请选择",
                  onChange: _ctx.onChangePackageZhId
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.Value,
                        label: item.Label,
                        value: item.Value,
                        style: {"width":"100% !important"}
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onChange"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageEn')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.Data.PackageEn,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.PackageEn) = $event)),
                  style: {"width":"100% !important"},
                  filterable: "",
                  disabled: _ctx.form.Data.PackageZhId != _ctx.undefind ? false : true,
                  "allow-create": "",
                  "default-first-option": "",
                  "reserve-keyword": false,
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageEnHistorys, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.Label,
                        label: item.Label,
                        value: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(item.Label), 1),
                          (item.Data.IsHistory==true)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                onClick: ($event: any) => (_ctx.onDeletePackageEn(item.Value,index))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_2))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "disabled"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageImages')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_upload, {
                  modelValue: _ctx.form.Data.PackageImages,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.PackageImages) = $event)),
                  path: "product/package",
                  accept: "image/*",
                  prop: "Url",
                  maxSize: 10 * 1024 * 1024
                }, null, 8, ["modelValue"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageShapes' && _ctx.type == '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.PackageShapes, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"width":"100% !important","padding-top":"10px"},
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_miezz_input, {
                        modelValue: p.Length,
                        "onUpdate:modelValue": ($event: any) => ((p.Length) = $event),
                        onHandleBlur: ($event: any) => (_ctx.onChangeLength(index)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_miezz_input, {
                        modelValue: p.Width,
                        "onUpdate:modelValue": ($event: any) => ((p.Width) = $event),
                        onHandleBlur: ($event: any) => (_ctx.onChangeWidth(index)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_miezz_input, {
                        modelValue: p.Height,
                        "onUpdate:modelValue": ($event: any) => ((p.Height) = $event),
                        onHandleBlur: ($event: any) => (_ctx.onChangeHeight(index)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_miezz_input, {
                        modelValue: p.Volume,
                        "onUpdate:modelValue": ($event: any) => ((p.Volume) = $event),
                        onHandleBlur: ($event: any) => (_ctx.onChangeVolume(index)),
                        disabled: p.isVolume == true ? false : true,
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_form_item, {
                        style: {"padding":"0px","margin":"0px","padding-bottom":"10px","padding-left":"2px"},
                        prop: `PackageShapes[${index}].NetWeight`,
                        rules: _ctx.form.Rules.PackageShapes_NetWeight
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: p.NetWeight,
                            "onUpdate:modelValue": ($event: any) => ((p.NetWeight) = $event),
                            onHandleBlur: ($event: any) => (_ctx.onChangeNetWeight(index)),
                            placeholder: '请填写',
                            style: {"width":"99% !important"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_form_item, {
                        style: {"padding":"0px","margin":"0px","padding-bottom":"10px","padding-left":"2px"},
                        prop: `PackageShapes[${index}].GrossWeight`,
                        rules: _ctx.form.Rules.PackageShapes_GrossWeight
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: p.GrossWeight,
                            "onUpdate:modelValue": ($event: any) => ((p.GrossWeight) = $event),
                            onHandleBlur: ($event: any) => (_ctx.onChangeGrossWeight(index)),
                            placeholder: '请填写',
                            style: {"width":"99% !important"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, {
                        prop: `PackageShapes[${index}].Quantity`,
                        rules: _ctx.form.Rules.PackageShapes_Quantity
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            disabled: true,
                            readonly: "",
                            modelValue: p.Quantity,
                            "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                            placeholder: '请填写',
                            style: {"width":"99% !important"},
                            onHandleBlur: ($event: any) => (_ctx.onChangeShapeQuantity(index))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageShapes' && _ctx.type != '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  (_ctx.form.Data.PackageShapes && _ctx.form.Data.PackageShapes?.length <= 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.form.Data.PackageShapes && _ctx.form.Data.PackageShapes?.length <= 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.PackageShapes, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"width":"100% !important","padding-top":"5px"},
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: ($event: any) => (_ctx.onChangeLength(index)),
                        modelValue: p.Length,
                        "onUpdate:modelValue": ($event: any) => ((p.Length) = $event),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: ($event: any) => (_ctx.onChangeWidth(index)),
                        modelValue: p.Width,
                        "onUpdate:modelValue": ($event: any) => ((p.Width) = $event),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: ($event: any) => (_ctx.onChangeHeight(index)),
                        modelValue: p.Height,
                        "onUpdate:modelValue": ($event: any) => ((p.Height) = $event),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_miezz_input, {
                        disabled: p.isVolume == true ? false : true,
                        modelValue: p.Volume,
                        "onUpdate:modelValue": ($event: any) => ((p.Volume) = $event),
                        onHandleBlur: ($event: any) => (_ctx.onChangeVolume(index)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onHandleBlur"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_form_item, {
                        style: {"padding":"0px","margin":"0px","padding-bottom":"10px","padding-left":"2px"},
                        prop: `PackageShapes[${index}].NetWeight`,
                        rules: _ctx.form.Rules.PackageShapes_NetWeight
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: p.NetWeight,
                            "onUpdate:modelValue": ($event: any) => ((p.NetWeight) = $event),
                            onHandleBlur: ($event: any) => (_ctx.onChangeNetWeight(index)),
                            placeholder: '请填写',
                            style: {"width":"99% !important"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_form_item, {
                        style: {"padding":"0px","margin":"0px","padding-bottom":"10px","padding-left":"2px"},
                        prop: `PackageShapes[${index}].GrossWeight`,
                        rules: _ctx.form.Rules.PackageShapes_GrossWeight
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: p.GrossWeight,
                            "onUpdate:modelValue": ($event: any) => ((p.GrossWeight) = $event),
                            onHandleBlur: ($event: any) => (_ctx.onChangeGrossWeight(index)),
                            placeholder: '请填写',
                            style: {"width":"99% !important"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    (_ctx.form.Data.PackageShapes && _ctx.form.Data.PackageShapes?.length <= 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_el_form_item, {
                            style: {"padding":"0px","margin":"0px","padding-bottom":"10px","padding-left":"2px"},
                            prop: `PackageShapes[${index}].Quantity`,
                            rules: _ctx.form.Rules.PackageShapes_Quantity
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: p.Quantity,
                                "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                placeholder: '请填写',
                                onHandleBlur: ($event: any) => (_ctx.onChangeShapeQuantity(index)),
                                style: {"width":"99% !important","margin-top":"2px"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.form.Data.PackageShapes && _ctx.form.Data.PackageShapes?.length <= 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("span", {
                            style: {"cursor":"pointer","color":"red"},
                            onClick: ($event: any) => (_ctx.onDeleteShape(index)),
                            title: "删除"
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_35)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("span", {
                            style: {"cursor":"pointer","color":"red"},
                            onClick: ($event: any) => (_ctx.onDeleteShape(index)),
                            title: "删除"
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_37)
                        ]))
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddShape())),
                    style: {"color":"#faad6a","cursor":"pointer","font-weight":"900","font-size":"14px"}
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 新增 ")
                  ])
                ]),
                (_ctx.form.Data.PackageShapes.length>1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, "多个尺寸代表一件产品被分装为多个小包装，此时产品数量只能为1"))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageSpecs' && _ctx.type != '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      (_ctx.form.Data.PackageShapes.length<=1)
                        ? (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: 0,
                            disabled: _ctx.form.Data.PackageShapes.length==1?false:true,
                            modelValue: _ctx.isSelected,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isSelected) = $event)),
                            size: "small",
                            onChange: _ctx.onChangeSpecAll
                          }, null, 8, ["disabled", "modelValue", "onChange"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_43, " "))
                    ])
                  ]),
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createTextVNode(" 包装内的数量"),
                      (_ctx.product != null && _ctx.product != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, "（" + _toDisplayString(_ctx.product.ChargeUnithZh) + "）", 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.specs != null && _ctx.specs != undefined && _ctx.specs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specs, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"height":"45px","clear":"both","width":"100% !important","padding-top":"10px","padding-bottom":"5px","border-bottom":"1px solid #efefef"}
                        }, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: p.IsSelected,
                              "onUpdate:modelValue": ($event: any) => ((p.IsSelected) = $event),
                              size: "large",
                              onChange: ($event: any) => (_ctx.onChangeSpecSelect(index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_50, _toDisplayString(p.Name), 1),
                          _createElementVNode("div", _hoisted_51, [
                            (p.IsSelected == true && _ctx.form.Data.PackageShapes.length < 2)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  style: {"padding":"0px","margin":"0px","padding-bottom":"10px","margin-left":"1px"},
                                  prop: `Specs[${index}].Quantity`,
                                  rules: _ctx.form.Rules.Specs_Quantity
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_input, {
                                      modelValue: p.Quantity,
                                      "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                      placeholder: '请填写',
                                      onHandleBlur: ($event: any) => (_ctx.onChangeQuantity(index)),
                                      style: {"width":"98% !important","margin-top":"2px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules"]))
                              : (p.IsSelected == true && _ctx.form.Data.PackageShapes.length > 1)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    style: {"padding":"0px","margin":"0px","padding-bottom":"10px","margin-left":"1px"},
                                    prop: `Specs[${index}].Quantity`,
                                    rules: _ctx.form.Rules.Specs_Quantity
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        readonly: "",
                                        disabled: true,
                                        modelValue: p.Quantity,
                                        "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                        placeholder: '请填写',
                                        onHandleBlur: ($event: any) => (_ctx.onChangeQuantity(index)),
                                        style: {"width":"95% !important","margin-top":"2px"}
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"]))
                                : (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 2,
                                    style: {"padding":"0px","margin":"0px","padding-bottom":"10px","margin-left":"1px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        disabled: true,
                                        modelValue: p.Quantity,
                                        "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                        placeholder: '请填写',
                                        style: {"width":"98% !important","margin-top":"2px"}
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_ctx.form.Data.ProductId != null && _ctx.form.Data.ProductId != undefined && _ctx.form.Data.ProductId != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, " 暂无数据 "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, " 请先选择所属产品 "))
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageSpecs' && _ctx.type == '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 9,
              prop: item.Prop,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _hoisted_54
              ]),
              default: _withCtx(() => [
                _hoisted_55,
                (_ctx.form.Data.Specs != null && _ctx.form.Data.Specs != undefined && _ctx.form.Data.Specs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Specs, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"width":"100% !important","padding-top":"5px","padding-bottom":"10px","height":"40px","line-height":"40px","border-bottom":"1px solid #efefef"}
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            (p.Product.NameEn!=undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(p.Product.NameZh) + " / " + _toDisplayString(p.Product.NameEn), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(p.Product.NameZh), 1))
                          ]),
                          _createElementVNode("div", _hoisted_60, _toDisplayString(p.Name), 1),
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_el_form_item, {
                              style: {"padding":"0px","margin":"0px","padding-bottom":"10px"},
                              prop: `Specs[${index}].Quantity`,
                              rules: _ctx.form.Rules.Specs_Quantity
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: p.Quantity,
                                  "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                  placeholder: '请填写',
                                  onHandleBlur: ($event: any) => (_ctx.onChangeQuantity(index)),
                                  style: {"width":"99% !important","margin-top":"2px"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            (p.Product.ChargeUnithEn!=undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(p.Product.ChargeUnithZh) + " / " + _toDisplayString(p.Product.ChargeUnithEn), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(p.Product.ChargeUnithZh), 1))
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","color":"red"},
                              onClick: ($event: any) => (_ctx.onDeleteSpec(index)),
                              title: "删除"
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_66)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, " 暂无数据 ")),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("span", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onAddSpec())),
                    style: {"color":"#faad6a","cursor":"pointer","font-weight":"900","font-size":"14px"}
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 新增 ")
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "modal-form",
          model: _ctx.modalData,
          rules: _ctx.modalRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "所属产品",
              prop: "ProductId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalData.ProductId,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalData.ProductId) = $event)),
                  options: _ctx.products,
                  valueKey: "Id",
                  onHandleChange: _ctx.onChangeModalProductId,
                  labelKey: "Name",
                  style: {"width":"100% !important"}
                }, null, 8, ["modelValue", "options", "onHandleChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "包装内的型号与数量" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.modalData.isSelected,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalData.isSelected) = $event)),
                        size: "small",
                        onChange: _ctx.onChangeModalSpecAll
                      }, null, 8, ["modelValue", "onChange"]),
                      _createTextVNode("   ")
                    ])
                  ]),
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createTextVNode(" 包装内的数量"),
                      (_ctx.product != null && _ctx.product != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_75, "（" + _toDisplayString(_ctx.product.ChargeUnithZh) + "）", 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.modalData.Specs != null && _ctx.modalData.Specs != undefined && _ctx.modalData.Specs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalData.Specs, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"height":"45px","clear":"both","width":"100% !important","padding-top":"10px","padding-bottom":"5px","border-bottom":"1px solid #efefef"}
                        }, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: p.IsSelected,
                              "onUpdate:modelValue": ($event: any) => ((p.IsSelected) = $event),
                              size: "large",
                              onChange: ($event: any) => (_ctx.onChangeModalSpecSelect(index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_78, _toDisplayString(p.Name), 1),
                          _createElementVNode("div", _hoisted_79, [
                            (p.IsSelected == true)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  prop: `Specs[${index}].Quantity`,
                                  rules: _ctx.modalRules.Specs_Quantity,
                                  style: {"padding":"0px","margin":"0px","padding-bottom":"10px","margin-left":"1px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_input, {
                                      modelValue: p.Quantity,
                                      "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                      placeholder: '请填写',
                                      onHandleBlur: ($event: any) => (_ctx.onChangeModalQuantity(index)),
                                      style: {"width":"98% !important","margin-top":"2px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules"]))
                              : (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  style: {"padding":"0px","margin":"0px","padding-bottom":"10px","margin-left":"1px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_input, {
                                      disabled: true,
                                      modelValue: p.Quantity,
                                      "onUpdate:modelValue": ($event: any) => ((p.Quantity) = $event),
                                      placeholder: '请填写',
                                      style: {"width":"98% !important","margin-top":"2px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_ctx.modalData.ProductId != null && _ctx.modalData.ProductId != undefined && _ctx.modalData.ProductId != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, " 暂无数据 "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_81, " 请先选择所属产品 "))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}